// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__8kdAY","inputWrap":"Table_inputWrap__jvBbo","col":"Table_col__2IM8F","bmiTooltip":"Table_bmiTooltip__1Y-Kl"};